/**
 * 新商品関連のQuery Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getNewProducts } from '@/lib/api/new-product';
import { newProductKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * 新商品一覧を取得するQuery Hook
 * @param accountCode アカウントコード
 * @param baseDate 基準日（YYYY-MM-DD形式）
 */
export function useNewProducts(accountCode: string, baseDate: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: newProductKeys.list(accountCode, baseDate),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getNewProducts(accountCode, baseDate, authHeaders);
    },
    enabled: !authHeaderLoading && isAuthorized && !!accountCode && !!baseDate,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
